module.exports = __webpack_public_path__ + "media/images/icons/double-quote-sans-left-5d218bb3639c800206832bdf141f114d.svg";